import useDisplayNames from '../useDisplayNames'

const useOngoingDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const value = getDisplayName('ongoing', 'Ongoing')

    return { value }
}

export default useOngoingDisplayName
